let rocket = null;

import { config } from '@js/state';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';
export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'StartScene',
    });
  }

  preload() {
    this.load.video('drivein', 'assets/GameSceneAssets/HYPERDRIVE_BEGINING.mp4');
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();
    for (let i = 0; i <= 6; i++) {
      for (let k = 1; k <= 6; k++) {
        this.load.image(
          'A_' + k + '_' + (i + 1),
          'assets/GameSceneAssets/A_' + k + '_' + (i + 1) + '.png',
        );
      }
      //this.load.image("A"+i, "assets/GameSceneAssets/A"+i+".png");

      this.load.image('L' + i, 'assets/GameSceneAssets/L' + i + '.png');

      for (let j = -1; j <= 9; j++) {
        //this.load.image(j+"_"+i, "assets/GameSceneAssets/"+j+"_"+i+".png");
        this.load.image(j + '_' + i, 'assets/GameSceneAssets/' + j + '_' + i + '.png');
      }
    }

    this.load.start();
    config.audio.bgAudio = this.sound.add('bgMusic').setLoop(true);

    this.video2audio = this.sound.add('video2audio').setVolume(0.1);

    const r5 = this.add
      .rectangle(0, 0, 1280, 720, 0xffffff)
      .setOrigin(0)
      .setDepth(15)
      .setAlpha(0);

    this.record = false;
    this.player = false;
    this.sbg = this.add.image(0, 0, 'sbg').setOrigin(0);

    this.playButton = this.add
      .image(536, 592, 'play_button')
      .setInteractive({ cursor: 'pointer' })
      .setOrigin(0, 0);

    //this.rocket = this.add.image(643,353+35,'rocket')

    //var path1 = new Phaser.Curves.Path(643, 353+35).splineTo([ 800, 300, 1000,150, 1300, -100 ]);

    //rocket = this.add.follower(path1,643,353+35,'rocket')
    rocket = this.add
      .sprite(643 - 239 / 2 + 50, 353 + 45 + 239 / 2 - 60, 'rocket')
      .setOrigin(50 / 239, 1 - 60 / 239);

    this.rpath = this.add.image(0, 293, 'rpath').setOrigin(0);

    this.gameName = this.add.image(390, 179, 'gameName').setOrigin(0);

    this.playButton.on(
      'pointerover',
      function (_pointer) {
        this.playButton.setTexture('play_button_on');
        //this.scene.pause("GameLoadScene");
      },
      this,
    );

    this.playButton.on(
      'pointerout',
      function (_pointer) {
        this.playButton.setTexture('play_button');
        //this.scene.resume("GameLoadScene");
      },
      this,
    );

    this.playButton.on(
      'pointerdown',
      function (_pointer) {
        enablePointerEvents();
        this.video2audio.play();

        config.audio.bgAudio.setVolume(0.012).play();

        //        config.audio.bgAudio.setLoop(true).setVolume(0.1).play();

        // this.gamename.setScale(0);
        this.playButton.setScale(0);

        //        var graphics = this.add.graphics();

        //    graphics.lineStyle(3, 0xffffff, 1);

        //    path1.draw(graphics, 128);

        //console.log(path1.getLength())

        //    rocket.startFollow({
        //      positionOnPath: true,
        //      duration: 3000,
        //      yoyo: false,
        //      repeat: 0,
        //      //rotateToPath: true,
        //      verticalAdjust: true
        //  });

        this.tweens.add({
          targets: rocket,
          //  targets:[this.bg,this.wspring1,this.wspring2,this.Lbar,this.Lboard,this.Rbar,,this.Rbar2,this.Rbox,this.Rstick,this.D1,D2,this.N1,N2,this.slot,this.slot2,this.lightpanel,graphics,graphics2,graphics3,this.graphics4,gameitems],
          x: 1300,
          duration: 1500,
          //delay:4000,
          ease: 'Linear',
        });

        this.tweens.add({
          targets: rocket,
          //  targets:[this.bg,this.wspring1,this.wspring2,this.Lbar,this.Lboard,this.Rbar,,this.Rbar2,this.Rbox,this.Rstick,this.D1,D2,this.N1,N2,this.slot,this.slot2,this.lightpanel,graphics,graphics2,graphics3,this.graphics4,gameitems],
          y: 0,
          duration: 1500,
          //delay:4000,
          ease: 'Sine.easeOut',
        });

        this.record = true;

        this.tweens.add({
          targets: r5,
          //  targets:[this.bg,this.wspring1,this.wspring2,this.Lbar,this.Lboard,this.Rbar,,this.Rbar2,this.Rbox,this.Rstick,this.D1,D2,this.N1,N2,this.slot,this.slot2,this.lightpanel,graphics,graphics2,graphics3,this.graphics4,gameitems],
          alpha: 1,
          duration: 500,
          delay: 2000,
          ease: 'Sine.easeInOut',
        });

        this.time.delayedCall(
          2500,
          () => {
            this.scene.start('GameScene');

            //this.scene.start("FinalScene");

            this.scene.stop('StartScene');
            //this.scene.start("EndScene");
          },
          [],
          this,
        );
      },
      this,
    );
  }

  startloads() {}

  update() {
    if (this.record) {
      this.record = false;
      this.A = rocket.x;
      this.B = rocket.y;
      this.time.delayedCall(
        16,
        () => {
          this.player = true;
        },
        this,
      );
    }

    if (this.player) {
      this.player = false;

      const graphics = this.add.graphics();

      graphics.lineStyle(1, 0xffffff, 0.8);

      graphics.lineBetween(this.A, this.B, rocket.x, rocket.y);

      this.time.delayedCall(
        16,
        () => {
          this.record = true;
        },
        this,
      );
    }
  }
}
